export default __webpack_public_path__ + "static/media/VivoBook.4823d72e.jpg";